import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Globals } from 'src/app/globals';

@Injectable({
    providedIn: 'root'
})

export class TrashService {
    constructor(private httpclient: HttpClient, private global: Globals) { }

   
    GetTrashList() {
        let headers:HttpHeaders=new HttpHeaders();
        headers=headers.append('Authorization', "Bearer " + this.global.loggedUser.token);
        return this.httpclient.get(this.global.G_apiUrl + '/approvedEmail/getDeleted/'+this.global.loggedUser.user.user_reg_id, { headers:headers });
    }

    TrashUndo(id:any){
        let headers:HttpHeaders=new HttpHeaders();
        headers=headers.append('Authorization', "Bearer " + this.global.loggedUser.token);
        return this.httpclient.delete(this.global.G_apiUrl + '/approvedEmail/restore/'+id, 
        {responseType:'text',headers: headers });
    }

    TrashUndoMultiple(list:any){
        let headers:HttpHeaders=new HttpHeaders();
        headers=headers.append('Authorization', "Bearer " + this.global.loggedUser.token);
        return this.httpclient.post(this.global.G_apiUrl + '/approvedEmail/multipleRestore',list, 
        {responseType:'text',headers:headers });
    }


    


}